var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconArrowUpRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.55123C12.6904 3.55123 13.25 4.11088 13.25 4.80123L13.25 19.8012C13.25 20.4916 12.6904 21.0512 12 21.0512C11.3096 21.0512 10.75 20.4916 10.75 19.8012L10.75 4.80123C10.75 4.11088 11.3096 3.55123 12 3.55123Z",
    fill: "#E41D00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45987 10.4639C4.97171 9.97577 4.97171 9.18431 5.45987 8.69616L10.4096 3.74641C11.2883 2.86773 12.7129 2.86773 13.5916 3.74641L18.5413 8.69616C19.0295 9.18431 19.0295 9.97577 18.5413 10.4639C18.0532 10.9521 17.2617 10.9521 16.7736 10.4639L12.0006 5.69096L7.22763 10.4639C6.73948 10.9521 5.94802 10.9521 5.45987 10.4639Z",
    fill: "#E41D00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowUpRed);
export default __webpack_public_path__ + "static/media/icon-arrow-up-red.9fa12690.svg";
export { ForwardRef as ReactComponent };